import { FC, ReactNode, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import { getCountsCategory, PROFILE_TYPE_CATEGORY, TYPE_PER_PRESET_TYPE } from "../../../constants/system-constants";
import PermissionTab from "../../../containers/permission-tab";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { Category } from "../../../models/Category";
import SystemStat from "../../../models/SystemStat";
import { getSystemStats } from "../../../services/systemService";
import { showError } from "../../../services/utilities/ServiceError";

const Permissions: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const { translate } = useLocale();

    useEffect(() => {
        buildCategoriesData();
    }, []);

    const buildCategoriesData = async () => {
        try {
            setBusy(true);
            const showTabCounts = window.sessionStorage.getItem("showTabCounts") === "1";
            const systemStat: SystemStat | undefined = showTabCounts ? await getSystemStats(TYPE_PER_PRESET_TYPE) : undefined;
            const count = systemStat ? getCountsCategory(systemStat, PROFILE_TYPE_CATEGORY.ROLES) : 0;
            setCategories([{
                displayName: translate.byKey(TranslationKeys.permissions),
                heading: translate.byKey(TranslationKeys.permissions),
                value: "",
                id: 0,
                count: count
            }]);

            setBusy(false);
        } catch (error) {
            showError(error, toast.warn);
        }
    }

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [<PermissionTab setBusy={setBusy} categories={categories} setCategories={setCategories}></PermissionTab>];
            setTabContent(newTabContent);
        }
    }, [categories]);

    return (
        <>
            <ActivityFrame busy={busy} className="flex flex-grow overflow-y-hidden">
                <div id="container-tabs" className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
                    <Breadcrumb
                        path={[
                            { value: '/access-control/operators', displayName: translate.byKey(TranslationKeys.operators), disableClick: true },
                            { value: "/access-control/operators/permissions", displayName: translate.byKey(TranslationKeys.permissions) }]}
                        onClick={(item) => history.push(item.value)}>
                    </Breadcrumb>
                    <Tabs
                        className="overflow-y-hidden"
                        tabs={getTabsListFromLabels(categories)}
                        onSelect={(i) => setSelected(i)}
                        selected={selected}
                        onAdd={() => { }}
                        add={false}
                        tabStyle={{}}>
                        {tabContent[selected]}
                        <div className="flex flex-row justify-end button-cluster">
                            {/* {Will be enabled on upcoming releases} */}
                            {/* <Restricted to={`add.permissions.element`}>
                                <Link to={{ pathname: "/access-control/operators/permission/" }}>
                                    <button className="flex rounded-lg bg-lime text-white p-2 shadow-lg">
                                        <img src={plusIcon} className="px-2 w-8 py-1" alt="" />
                                        <span className="mr-2">{translate.byKey(TranslationKeys.add)}</span>
                                    </button>
                                </Link>
                            </Restricted> */}
                        </div>
                    </Tabs>
                </div>
            </ActivityFrame>
        </>
    );
};

export default Permissions;
